var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classnames from 'classnames';
import { AppStatus } from '../common/constants';
import { default as Button } from './button';
var UButton = /** @class */ (function (_super) {
    __extends(UButton, _super);
    function UButton(props) {
        return _super.call(this, props) || this;
    }
    UButton.prototype.render = function () {
        var _this = this;
        var _a = this.state, _b = _a.data, data = _b === void 0 ? {} : _b, _c = _a.style, _d = _c.outer, buttonStyle = _d === void 0 ? {} : _d, _e = _c.loading, loadingStyle = _e === void 0 ? {} : _e, _f = _c.text, textStyle = _f === void 0 ? {} : _f, appStatus = _a.appStatus, _g = _a.progress, progress = _g === void 0 ? 0 : _g;
        var showText = [
            data.init,
            data.loading,
            data.downloadPause,
            data.downloadFail,
            data.downloaded,
            (data.installing || data.downloaded),
            data.installed
        ][appStatus] || data.init || '';
        showText = showText.replace('_PROGRESS_', isNaN(progress) ? 0 : progress);
        var _h = this.props, _j = _h.className, className = _j === void 0 ? '' : _j, _k = _h.app, app = _k === void 0 ? {} : _k, id = _h.id, _l = _h.ui, ui = _l === void 0 ? {} : _l;
        var btnClassName = [AppStatus.DOWNLOADING, AppStatus.DOWNLOAD_PAUSE].includes(appStatus) ? 'loading' : '';
        loadingStyle = __assign(__assign({ position: 'absolute', height: '100%' }, loadingStyle), { width: "".concat(progress || 0, "%"), display: btnClassName === 'loading' ? loadingStyle.display : 'none' });
        var restAttrs = { id: id, 'data-smp': ui.key };
        return (React.createElement("div", __assign({ "AEGIS-IGNORE-FIRST-SCREEN-TIMING": true, className: classnames(className, 'smp-ui-ubutton', btnClassName), ref: function (ref) { _this.compRef = ref; }, style: __assign({ position: 'relative', overflow: 'hidden' }, buttonStyle), onClick: this.handleClick.bind(this) }, restAttrs),
            React.createElement("div", { className: "smp-ui-button-progress", style: loadingStyle }),
            React.createElement("div", { className: "smp-ui-button-txt", style: __assign({ position: 'relative', zIndex: 2 }, textStyle) }, showText || this.props.children)));
    };
    return UButton;
}(Button));
export default UButton;
